import parsePhoneNumberFromString, {
  parsePhoneNumber,
} from 'libphonenumber-js';

/**
 * Masks a phone number
 * Removes a +1 country code if present
 * Formats the phone number as (123) 456-7890 if the number contains 10 digits
 * Any numbers greater 10 in length will be treated as an extension: (123) 456-7890 x1234
 *
 * @param phoneNumber - The phone number to be masked.
 * @returns The masked phone number or the original phone number if it contains non-digit characters.
 */
const maskPhoneNumber = (phoneNumber: string): string => {
  try {
    const parsedNumber = parsePhoneNumberFromString(phoneNumber, 'US');
    if (!parsedNumber) {
      return phoneNumber;
    }
    if (parsedNumber.nationalNumber.length > 10) {
      return parsedNumber.nationalNumber.replace(
        /(\d{3})(\d{3})(\d{4})(\d)/,
        '($1) $2-$3 x$4',
      );
    }
    return parsePhoneNumber(phoneNumber, 'US').formatNational();
  } catch (error) {
    return phoneNumber;
  }
};

export default maskPhoneNumber;
